import { useEffect } from 'react'

import { useAsyncError } from '@/modules/errors'
import { usePlansStore } from '../stores/plans'

export const useLoadingPlans = () =>
  usePlansStore((state) => state.loadingPlans)

export const usePlans = () => usePlansStore((state) => state.plans)

export const usePlansLoaders = () => usePlansStore((state) => state.loaders)
export const usePlansActions = () => usePlansStore((state) => state.actions)

export const useFetchPlans = () => {
  const loaders = usePlansLoaders()
  const throwError = useAsyncError()

  useEffect(() => {
    loaders.fetchPlans().catch(throwError)
  }, [])
}
